export class ItdStates {
    public static DRAFT: ItdState = {Id: 0, Name: "Не передано", ExtName: "DRAFT"};
    public static REVIEW: ItdState = {Id: 1, Name: "На согласовании", ExtName: "REVIEW"};
    public static VERIFIED: ItdState = {Id: 2, Name: "Согласовано", ExtName: "VERIFIED"};
    public static REMARKS: ItdState = {Id: 3, Name: "Получены замечания", ExtName: "REMARKS"};
    public static SIGN: ItdState = {Id: 4, Name: "Документ на подписании", ExtName: "SIGN"};
    public static APPROVED: ItdState = {Id: 5, Name: "Подписан", ExtName: "APPROVED"};
}
export class ItdDocumentStates {
    public static ON_APPROVAL: ItdState = {Id: 0, Name: "На согласовании", ExtName: "ON_APPROVAL"};
    public static CANCELED: ItdState = {Id: 1, Name: "Аннулирован", ExtName: "CANCELED"};
    public static NEW: ItdState = {Id: 2, Name: "Новый", ExtName: "NEW"};
    public static REVISION: ItdState = {Id: 3, Name: "На доработке", ExtName: "REVISION"};
    public static SIGNED: ItdState = {Id: 4, Name: "Подписан", ExtName: "SIGNED"};
}

export interface ItdState { 
    Id: number
    Name: string
    ExtName: string
}